@if (npc) {
  <div >
    @if (npc.char['main']['Deceased'] ) {
      <b>Deceased {{npc.char['main']['Deceased']}} </b>
    }
    @if (npc.char['description']) {
      <p>{{npc.char['description']}}</p>
    }
    @if (npc.char['url']) {
      <img width="100%" src="{{npc.char['url']}}"/>
    }
    <br/>
    <a routerLink="/character/{{npc.char['name']}}">Link</a><br/>
    <table width="100%">
      @for (m of npc.char['stats'] | keyvalue; track m) {
        <tr><th style="text-transform:'uppercase'">{{m.key}}</th><td>{{m.value}}</td></tr>
      }
      @for (m of npc.char['main'] | keyvalue ; track m) {
        @if (isEq(m.key, 'Born')) {
          <tr >
            <th>Age</th><td>{{npc.year - m.value*1}}</td>
          </tr>
        }
        <tr><th>{{m.key}}</th><td>{{m.value}}</td></tr>
      }
      @for (m of npc.char['skills']['Other'] | keyvalue; track m) {
        <tr><th>{{m.key}}</th><td>{{m.value}}</td></tr>
      }
      @for (m of npc.char['skills']['Weapons'] | keyvalue; track m) {
        <tr><th>{{m.key}}</th><td>{{m.value}}</td></tr>
      }
      @for (m of npc.char['skills']['Combat'] | keyvalue; track m) {
        <tr><th>{{m.key}}</th><td>{{m.value}}</td></tr>
      }
      @for (g of npc.char['passions'] | passionGroups; track g) {
        @if (g.category !== 'Other') {
          <tr class="passion-cat"><th colspan="2">{{g.category}} (<span [class.passion-warn]="g.total > 40">{{g.total}}</span>)</th></tr>
        }
        @for (m of g.items; track m) {
          <tr><th>{{m.key}}</th><td>{{m.value}}</td></tr>
        }
      }
    </table>
  </div>
} @else {
  Loading
}
